// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"gp","speechCardBox":"gp","speech-img-box":"gq","speechImgBox":"gq","card-content":"gr","cardContent":"gr","card-src":"gs","cardSrc":"gs"};